export default import.meta.ROLLUP_FILE_URL_C2VzYNwf;